import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	padding: 40px 0;

	${minWidth('tablet')} {
		padding: 64px 0;
	}
`;

export const Grid = styled(GridWrapper)`
	grid-template-columns: 1fr;
`;

export const ContentWrapper = styled.div`
	color: ${palette('gray8')};
	margin: 0 auto;
	max-width: 760px;
	text-align: center;
`;

export const QuoteText = styled.h3`
	${fontWeight(FontWeights.Regular)};
`;

export const CitationText = styled.h4`
	${fontWeight(FontWeights.Regular)};
	margin-top: 24px;

	${minWidth('desktop')} {
		margin-top: 40px;
	}
`;
